import {
  emailService,
  emailJSPubKey,
  contactFormEmailTemplate,
  donationNotificationEmailTemplate,
  donationConfirmationEmailTemplate,
} from "../../util/backendUtilities";

import emailjs from "@emailjs/browser";

export const sendEmail = async (emailData) => {
  const { name, phoneNumber, subject, message } = emailData;
  const templateParams = {
    to_name: name,
    phone: phoneNumber,
    subject,
    message,
  };

  try {
    await emailjs.send(
      emailService,
      contactFormEmailTemplate,
      templateParams,
      emailJSPubKey
    );
    return "Your message was sent";
  } catch (err) {
    return `There was an error sending: ${err.message}`;
  }
};

export const sendDonationNotification = async (emailData) => {
  const { firstName, lastName, email, amount } = emailData;
  const templateParams = {
    first_name: firstName,
    last_name: lastName,
    email,
    amount,
  };

  try {
    await emailjs.send(
      emailService,
      donationNotificationEmailTemplate,
      templateParams,
      emailJSPubKey
    );
  } catch (err) {
    console.log(err);
  }
};

export const sendDonationConfirmation = async (emailData) => {
  const { firstName, lastName, email, amount } = emailData;
  const timestamp = Date();
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const formattedTimestamp = timestamp.toLocaleString("en-US", options);

  const templateParams = {
    first_name: firstName,
    last_name: lastName,
    email,
    amount,
    timestamp: formattedTimestamp,
  };

  try {
    await emailjs.send(
      emailService,
      donationConfirmationEmailTemplate,
      templateParams,
      emailJSPubKey
    );
    return "An email has been sent";
  } catch (err) {
    console.log(err);
    return `An error occurred sending an email: ${err.text}`;
  }
};
